app.factory('teacherAppService', ['$http', '$q', '$window', '$interval', '$rootScope', 'gameService', function ($http, $q, $window, $interval, $rootScope, gameService) {
	var service = this;

	service.gameInfo = [];
	service.gameDayInfo = {};
	service.started = false;
	service.hasImage = false;
	service.paused = false;
	service.currentGroup = 0;
	service.currentGameInfo = {};
	service.groupPickerScrollOffset = 0;

	service.isReady = function() {
		return service.gameInfo.length > 0;
	}

	service.setCurrentGroup = function(idx) {
		service.currentGroup = idx;
		service.currentGameInfo = service.gameInfo[service.currentGroup]; 
	}

	service.startAndSyncImmediately = function() {
		if (service.started) {
			return $q(function(resolve, reject) {
				resolve();
			});
		}

		// Sync once a while, at the interval specified in the config.
		$interval(function() {
			if (service.paused) {
				return;
			}
			service.fullSync({noImage: true});
		}, (gameService.config.teacherAppUpdateIntervalSecs || 10) * 1000.0);

		service.started = true;

		// Sync now.
		return service.fullSync({noImage: true});
	}

	service.fullSync = function(opts) {
		return $q(function(resolve, reject) {
			var url = "/api/game/full";
			if (opts !== undefined && opts.noImage !== undefined) {
				if (opts.noImage) {
					url += "?noimg=1";
				}
			}
			$http.get(url).then(function(response) {
					service.gameInfo = response.data.gameInfo;
					service.gameDayInfo = response.data.gameDayInfo;
					$rootScope.$broadcast('teacherAppServiceUpdated', service.gameInfo);
					resolve();
				},
				function() {
					reject();
				}).catch(function() {
					reject();
				});
		});
	}

	return service;
}]);